import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '../components/dialog/dialog.module';
import { ProgressSpinnerModule } from '../components/progress-spinner/progress-spinner.module';

import { ReadableErrorPipe } from '../core/error-messages';
import { LoadingDialogComponent } from '../loading-dialog/loading-dialog.component';
import { NoScrollDirective } from './directives/no-scroll.directive';
import { RippleDirective } from './directives/ripple.directive';
import { RecreateViewDirective } from './recreate-view.directive';
import { MaterialElevationDirective } from './utils/material-elevation-directive';
import {
  AgePipe,
  AmountPipe,
  CanEditPipe,
  CnpjFormatPipe,
  CompleteDifferenceDate,
  CpfFormatPipe,
  DateDiffPipe,
  FindPipe,
  FormatDate,
  FormatDocumentPipe,
  HasTravelTimePipePipe,
  IdentityFormatPipe,
  MapPipe,
  NameInitialsPipe,
  PendingStatus,
  PersonActivePipe,
  RefusalReasonCategoriesPipe,
  RouterBuilderPipe,
  SequencerPipe,
  SomePipe,
  StringPipe,
  ToHourPipe,
} from './utils/pipes';

@NgModule({
  imports: [CommonModule, DialogModule, ProgressSpinnerModule],
  providers: [CompleteDifferenceDate],
  declarations: [
    LoadingDialogComponent,
    MaterialElevationDirective,
    AgePipe,
    CpfFormatPipe,
    CnpjFormatPipe,
    IdentityFormatPipe,
    FormatDocumentPipe,
    NameInitialsPipe,
    SomePipe,
    FormatDate,
    MapPipe,
    DateDiffPipe,
    ReadableErrorPipe,
    FindPipe,
    StringPipe,
    RecreateViewDirective,
    NoScrollDirective,
    RippleDirective,
    RouterBuilderPipe,
    SequencerPipe,
    ToHourPipe,
    HasTravelTimePipePipe,
    PersonActivePipe,
    CanEditPipe,
    AmountPipe,
    PendingStatus,
    RefusalReasonCategoriesPipe,
    CompleteDifferenceDate,
  ],
  exports: [
    CommonModule,
    MaterialElevationDirective,
    DialogModule,
    ProgressSpinnerModule,
    AgePipe,
    CpfFormatPipe,
    CnpjFormatPipe,
    IdentityFormatPipe,
    NameInitialsPipe,
    SomePipe,
    FormatDate,
    MapPipe,
    DateDiffPipe,
    ReadableErrorPipe,
    FormatDocumentPipe,
    FindPipe,
    StringPipe,
    RecreateViewDirective,
    RouterBuilderPipe,
    SequencerPipe,
    ToHourPipe,
    HasTravelTimePipePipe,
    PersonActivePipe,
    CanEditPipe,
    AmountPipe,
    PendingStatus,
    RefusalReasonCategoriesPipe,
    CompleteDifferenceDate,
    RippleDirective,
  ],
})
export class SharedModule {}
